import React from "react";
import {
  approxMarginPnlUsdt,
  approxMarginRoiFromPriceMovePercent,
  formatApproxUsdtAmount,
  formatRoiPercentLabel,
} from "@/utils/marginRoiFromPriceMove";

interface PriceMoveRoiHintProps {
  variant: "tp" | "sl";
  percentStr: string;
  leverage: number;
  /** Margin in USDT (same as position "amount" in the form). */
  marginUsdt?: number;
}

/**
 * Explains that TP/SL % fields are price moves from entry; shows approximate
 * ROI on margin (× leverage) when a value is set.
 */
export const PriceMoveRoiHint: React.FC<PriceMoveRoiHintProps> = ({
  variant,
  percentStr,
  leverage,
  marginUsdt,
}) => {
  const parsed = Number(percentStr);
  const roi = approxMarginRoiFromPriceMovePercent(parsed, leverage);

  if (roi == null) {
    return (
      <p className="text-[11px] font-medium text-text-muted leading-snug mt-0.5">
        ~ ROI
      </p>
    );
  }

  const label = formatRoiPercentLabel(roi);
  const usd =
    marginUsdt != null
      ? approxMarginPnlUsdt(marginUsdt, parsed, leverage)
      : null;
  const usdPart =
    usd != null ? (
      <span className="opacity-90">
        {" "}
        (~{variant === "tp" ? "+" : "-"}${formatApproxUsdtAmount(usd)})
      </span>
    ) : null;

  if (variant === "tp") {
    return (
      <p className="text-[11px] font-medium leading-snug text-emerald-400 mt-0.5">
        {label}% ROI
        {usdPart}
      </p>
    );
  }
  return (
    <p className="text-[11px] font-medium leading-snug text-red-400 mt-0.5">
      -{label}% ROI
      {usdPart}
    </p>
  );
};
